module.exports = __webpack_public_path__ + "static/media/pct.1313271c.svg";